import { render, staticRenderFns } from "./VueVideoBackground.vue?vue&type=template&id=b6c6e168&scoped=true&"
import script from "./VueVideoBackground.vue?vue&type=script&lang=js&"
export * from "./VueVideoBackground.vue?vue&type=script&lang=js&"
import style0 from "./VueVideoBackground.vue?vue&type=style&index=0&id=b6c6e168&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c6e168",
  null
  
)

component.options.__file = "VueVideoBackground.vue"
export default component.exports